import React from 'react';
import PropTypes from 'prop-types';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';
import ToggleButton from './ToggleButton';

export default {
  title: 'Components/Button/ToggleButton',
  component: ToggleButton,
  parameters: {
    layout: 'centered',
    ...generateComponentDocs(
      // What problem does it solve?
      '\nThe `ToggleButton` component provides a reusable button to toggle states.\n\n',
      // When & how to use it?
      '\nUse the `ToggleButton` component when you need to display this type of button according to the mockup.\n\n',
      // Current Usage
      '\nThe `ToggleButton` component is used on the New Site Page to manually set site coordinates.\n\n',
    ),
  },
  tags: ['autodocs'],
  argTypes: {
    isOn: { control: 'boolean' },
    label: { control: 'text' },
  },
};

const Template = (args) => <ToggleButton {...args} />;

export const ToggleOff = Template.bind({});

ToggleOff.args = {
  isOn: false,
  label: 'Toggle Button',
};

ToggleOff.storyName = 'Toggle Button Off';
ToggleOff.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThe `ToggleButton` "Off" variant is used to display the inactive state according to the mockup.\n\n',
  // Where is it currently used on the product?
  '\nThis variant is used on the New Site Page.\n\n',
);

export const ToggleOn = Template.bind({});
ToggleOn.args = {
  isOn: true,
  label: 'Toggle Button',
};

ToggleOn.storyName = 'Toggle Button On';
ToggleOn.parameters = generateStoryDocs(
  // When is this variant used?
  '\nThe `ToggleButton` "On" variant is used to display the active state according to the mockup.\n\n',
  // Where is it currently used on the product?
  '\nThis variant is used on the New Site Page.\n\n',
);

ToggleButton.propTypes = {
  isOn: PropTypes.bool,
  label: PropTypes.string,
};
